import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { getDashboardPath } from '../config/menuRegistry'
import { isMobileDevice } from '../utils/deviceDetect'

/**
 * Dashboard Router
 * 사용자 유형 / active_role 에 따라 적절한 대시보드로 리다이렉트
 *  - 협력사 active_role 이 있으면 그것 우선 (양쪽 capability 시 선택된 역할)
 *  - 단일 capability 협력사 → user_type 으로 자동 결정
 *  - 관리자/담당자 → user_type 직접 사용
 *
 * Phase Q D-H1: 모바일 기기에서 직접 /mobile/dashboard/* 로 라우팅 (2-step bounce 제거)
 */
const MOBILE_DASHBOARD_PATHS = {
  // Phase GK: mold_developer/staff 도 system-admin 모바일 대시보드 사용 (PC 와 동일)
  system_admin:   '/mobile/dashboard/system-admin',
  mold_developer: '/mobile/dashboard/system-admin',
  staff:          '/mobile/dashboard/system-admin',
  maker:          '/mobile/dashboard/maker',
  plant:          '/mobile/dashboard/plant',
};

export default function Dashboard() {
  const { user } = useAuthStore()
  const ADMIN = ['system_admin', 'mold_developer', 'staff']
  const isAdmin = ADMIN.includes(user?.user_type)
  const effectiveRole = isAdmin ? user.user_type : (user?.active_role || user?.user_type)

  // 모바일 디바이스에서는 모바일 대시보드 라우트로 직접 이동 (이전: PC 라우트 → mobile guard → 2-step bounce)
  if (isMobileDevice()) {
    const mobilePath = MOBILE_DASHBOARD_PATHS[effectiveRole] || '/mobile/dashboard/system-admin'
    return <Navigate to={mobilePath} replace />
  }

  const dashboardPath = getDashboardPath(effectiveRole) || '/dashboard/system-admin'
  return <Navigate to={dashboardPath} replace />
}
